module.exports = __webpack_public_path__ + "img/img26.e199ef24.svg";